define("settings/components/meta-marketing-api/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <section class="tAC--section u--m__t__lg qa--settings__metaMarketingApi">
    <h3 class="u--m__b__sm u--m__t__0">{{t "account.meta_marketing_api.title"}}</h3>
  
    {{#if this.isConnected}}
      <div class="tAC--mmaConnectedCard" {{did-insert this.onConnectedCardInserted}}>
        <div class="tAC--mmaConnectedCard__header">
          <div class="tAC--mmaConnectedCard__identity">
            <h4 class="tAC--mmaConnectedCard__name qa--settings__metaMarketingApi__accountName">
              {{this.displayAccountName}}
            </h4>
            <div class="tAC--mmaTokenChip tAC--mmaTokenChip--{{this.tokenStatus.tier}}">
              <span aria-hidden="true" class="tAC--mmaTokenChip__dot"></span>
              <span class="tAC--mmaTokenChip__label">{{this.tokenStatus.label}}</span>
              {{#if this.tokenStatus.detail}}
                <span class="tAC--mmaTokenChip__detail">{{this.tokenStatus.detail}}</span>
              {{/if}}
            </div>
            {{#if this.metaAdUser.tokenExpiresAt}}
              <div class="tAC--mmaTokenChip__date">
                {{format-date this.metaAdUser.tokenExpiresAt "medium"}}
              </div>
            {{/if}}
          </div>
          <div class="tAC--mmaConnectedCard__buttons">
            <Shared::Ui::Button
              @promise={{this.metaMarketingApiAuth.connect}}
              @size="small"
              @text={{t "account.meta_marketing_api.reconnect_button"}}
              @variant="outline"
              class="qa--settings__metaMarketingApi__reconnect"
            />
            <Shared::Ui::Button
              @promise={{this.metaMarketingApiAuth.disconnect}}
              @size="small"
              @text={{t "account.meta_marketing_api.disconnect_button"}}
              @variant="danger"
              class="qa--settings__metaMarketingApi__disconnect"
            />
          </div>
        </div>
  
        <div class="tAC--mmaConnectedCard__body">
          <Shared::Ui::Button
            @onClick={{perform this.copyTask this.metaAdUser.accessToken}}
            @size="small"
            @text={{t "account.meta_marketing_api.copy_access_token_button"}}
            @variant="outline"
            class="qa--settings__metaMarketingApi__copyToken"
            title={{t "account.meta_marketing_api.copy_token.hint"}}
          />
        </div>
  
        <div class="tAC--mmaConnectedCard__cta">
          <Shared::Ui::Button
            @promise={{this.fetchAdAccountsTask}}
            @size="small"
            @text={{t "account.meta_marketing_api.playground.ad_accounts.button"}}
            @variant="primary"
            class="qa--settings__metaMarketingApi__fetchAdAccounts"
          />
        </div>
      </div>
  
      {{#if this.adAccountsResult}}
        {{#if this.parsedAdAccounts}}
          <div class="tAC--mmaAccountsGrid u--m__t__md qa--settings__metaMarketingApi__adAccountsList">
            {{#each this.parsedAdAccounts as |account|}}
              {{#let (this.insightsFor account.id) (this.accountStatusInfo account) as |insights status|}}
                <div
                  class="tAC--mmaAccountTile {{if (eq insights.status 'success') 'tAC--mmaAccountTile--expanded'}}"
                  data-account-id={{account.id}}
                >
                  <div class="tAC--mmaAccountTile__head">
                    <span class="tAC--mmaAccountTile__name">
                      {{or account.name (t "account.meta_marketing_api.playground.ad_accounts.unnamed")}}
                    </span>
                    <span class="tAC--mmaAccountStatusChip tAC--mmaAccountStatusChip--{{status.tier}}">
                      {{status.label}}
                    </span>
                  </div>
                  <Shared::Ui::Button
                    @onClick={{perform this.copyTask account.id}}
                    @variant="unstyled"
                    class="tAC--mmaCopyableCode tAC--mmaAccountTile__id"
                    title={{t "account.meta_marketing_api.playground.ad_accounts.copy_id_hint"}}
                  >
                    {{account.id}}
                  </Shared::Ui::Button>
                  <div class="tAC--mmaAccountTile__action">
                    {{#if (eq insights.status "success")}}
                      <Shared::Ui::Button
                        @onClick={{fn this.collapseInsights account.id}}
                        @size="small"
                        @text={{t "account.meta_marketing_api.playground.ad_accounts.hide_insights_button"}}
                        @variant="outline"
                        class="qa--settings__metaMarketingApi__hideInsights"
                      />
                    {{else}}
                      <Shared::Ui::Button
                        @isDisabled={{eq insights.status "loading"}}
                        @onClick={{fn (perform this.fetchAccountInsightsTask) account.id}}
                        @size="small"
                        @text={{t "account.meta_marketing_api.playground.ad_accounts.get_insights_button"}}
                        @variant="outline"
                        class="qa--settings__metaMarketingApi__getInsights"
                      />
                    {{/if}}
                  </div>
  
                  {{#if (eq insights.status "success")}}
                    <div class="tAC--mmaAccountTile__insights">
                      <MetaMarketingApi::InsightsCard
                        @accountId={{account.id}}
                        @accountName={{account.name}}
                        @metrics={{insights.metrics}}
                      />
                    </div>
                  {{else if (eq insights.status "error")}}
                    <p class="tAC--mmaInsightsError">
                      {{t "account.meta_marketing_api.playground.ad_accounts.insights_error"}}
                    </p>
                  {{/if}}
                </div>
              {{/let}}
            {{/each}}
          </div>
        {{else}}
          <p class="u--text--light u--m__t__sm u--m__b__0">
            {{t "account.meta_marketing_api.playground.ad_accounts.empty"}}
          </p>
        {{/if}}
        <details class="tAC--mmaRawDetails">
          <summary class="tAC--mmaRawSummary">
            {{t "account.meta_marketing_api.playground.raw_response"}}
          </summary>
          <pre class="tAC--mmaSnippet">{{this.adAccountsResult}}</pre>
        </details>
      {{/if}}
    {{else}}
      <div class="tAC--mmaHero qa--settings__metaMarketingApi__hero">
        <div aria-hidden="true" class="tAC--mmaHero__glyph">
          <svg viewBox="0 0 64 40">
            <path
              d="M 12 20 C 12 8, 28 8, 32 20 C 36 32, 52 32, 52 20 C 52 8, 36 8, 32 20 C 28 32, 12 32, 12 20 Z"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="5"
            />
          </svg>
        </div>
        <h4 class="tAC--mmaHero__heading">
          {{t "account.meta_marketing_api.disconnected.hero_heading"}}
        </h4>
        <p class="tAC--mmaHero__subhead">
          {{t "account.meta_marketing_api.disconnected.hero_subhead"}}
        </p>
        <Shared::Ui::Button
          @promise={{this.metaMarketingApiAuth.connect}}
          @text={{t "account.meta_marketing_api.connect_button"}}
          @variant="default"
          class="tAC--mmaHero__button qa--settings__metaMarketingApi__connect"
        />
      </div>
    {{/if}}
  </section>
  */
  {
    "id": "0Sy+Wnyp",
    "block": "[[[10,\"section\"],[14,0,\"tAC--section u--m__t__lg qa--settings__metaMarketingApi\"],[12],[1,\"\\n  \"],[10,\"h3\"],[14,0,\"u--m__b__sm u--m__t__0\"],[12],[1,[28,[35,0],[\"account.meta_marketing_api.title\"],null]],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isConnected\"]],[[[1,\"    \"],[11,0],[24,0,\"tAC--mmaConnectedCard\"],[4,[38,2],[[30,0,[\"onConnectedCardInserted\"]]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaConnectedCard__header\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tAC--mmaConnectedCard__identity\"],[12],[1,\"\\n          \"],[10,\"h4\"],[14,0,\"tAC--mmaConnectedCard__name qa--settings__metaMarketingApi__accountName\"],[12],[1,\"\\n            \"],[1,[30,0,[\"displayAccountName\"]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[15,0,[29,[\"tAC--mmaTokenChip tAC--mmaTokenChip--\",[30,0,[\"tokenStatus\",\"tier\"]]]]],[12],[1,\"\\n            \"],[10,1],[14,\"aria-hidden\",\"true\"],[14,0,\"tAC--mmaTokenChip__dot\"],[12],[13],[1,\"\\n            \"],[10,1],[14,0,\"tAC--mmaTokenChip__label\"],[12],[1,[30,0,[\"tokenStatus\",\"label\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"tokenStatus\",\"detail\"]],[[[1,\"              \"],[10,1],[14,0,\"tAC--mmaTokenChip__detail\"],[12],[1,[30,0,[\"tokenStatus\",\"detail\"]]],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"],[41,[30,0,[\"metaAdUser\",\"tokenExpiresAt\"]],[[[1,\"            \"],[10,0],[14,0,\"tAC--mmaTokenChip__date\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[[30,0,[\"metaAdUser\",\"tokenExpiresAt\"]],\"medium\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tAC--mmaConnectedCard__buttons\"],[12],[1,\"\\n          \"],[8,[39,4],[[24,0,\"qa--settings__metaMarketingApi__reconnect\"]],[[\"@promise\",\"@size\",\"@text\",\"@variant\"],[[30,0,[\"metaMarketingApiAuth\",\"connect\"]],\"small\",[28,[37,0],[\"account.meta_marketing_api.reconnect_button\"],null],\"outline\"]],null],[1,\"\\n          \"],[8,[39,4],[[24,0,\"qa--settings__metaMarketingApi__disconnect\"]],[[\"@promise\",\"@size\",\"@text\",\"@variant\"],[[30,0,[\"metaMarketingApiAuth\",\"disconnect\"]],\"small\",[28,[37,0],[\"account.meta_marketing_api.disconnect_button\"],null],\"danger\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"tAC--mmaConnectedCard__body\"],[12],[1,\"\\n        \"],[8,[39,4],[[24,0,\"qa--settings__metaMarketingApi__copyToken\"],[16,\"title\",[28,[37,0],[\"account.meta_marketing_api.copy_token.hint\"],null]]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[28,[37,5],[[30,0,[\"copyTask\"]],[30,0,[\"metaAdUser\",\"accessToken\"]]],null],\"small\",[28,[37,0],[\"account.meta_marketing_api.copy_access_token_button\"],null],\"outline\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"tAC--mmaConnectedCard__cta\"],[12],[1,\"\\n        \"],[8,[39,4],[[24,0,\"qa--settings__metaMarketingApi__fetchAdAccounts\"]],[[\"@promise\",\"@size\",\"@text\",\"@variant\"],[[30,0,[\"fetchAdAccountsTask\"]],\"small\",[28,[37,0],[\"account.meta_marketing_api.playground.ad_accounts.button\"],null],\"primary\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"adAccountsResult\"]],[[[41,[30,0,[\"parsedAdAccounts\"]],[[[1,\"        \"],[10,0],[14,0,\"tAC--mmaAccountsGrid u--m__t__md qa--settings__metaMarketingApi__adAccountsList\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"parsedAdAccounts\"]]],null]],null],null,[[[44,[[28,[30,0,[\"insightsFor\"]],[[30,1,[\"id\"]]],null],[28,[30,0,[\"accountStatusInfo\"]],[[30,1]],null]],[[[1,\"              \"],[10,0],[15,0,[29,[\"tAC--mmaAccountTile \",[52,[28,[37,9],[[30,2,[\"status\"]],\"success\"],null],\"tAC--mmaAccountTile--expanded\"]]]],[15,\"data-account-id\",[30,1,[\"id\"]]],[12],[1,\"\\n                \"],[10,0],[14,0,\"tAC--mmaAccountTile__head\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"tAC--mmaAccountTile__name\"],[12],[1,\"\\n                    \"],[1,[28,[35,10],[[30,1,[\"name\"]],[28,[37,0],[\"account.meta_marketing_api.playground.ad_accounts.unnamed\"],null]],null]],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,1],[15,0,[29,[\"tAC--mmaAccountStatusChip tAC--mmaAccountStatusChip--\",[30,3,[\"tier\"]]]]],[12],[1,\"\\n                    \"],[1,[30,3,[\"label\"]]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[8,[39,4],[[24,0,\"tAC--mmaCopyableCode tAC--mmaAccountTile__id\"],[16,\"title\",[28,[37,0],[\"account.meta_marketing_api.playground.ad_accounts.copy_id_hint\"],null]]],[[\"@onClick\",\"@variant\"],[[28,[37,5],[[30,0,[\"copyTask\"]],[30,1,[\"id\"]]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                  \"],[1,[30,1,[\"id\"]]],[1,\"\\n                \"]],[]]]]],[1,\"\\n                \"],[10,0],[14,0,\"tAC--mmaAccountTile__action\"],[12],[1,\"\\n\"],[41,[28,[37,9],[[30,2,[\"status\"]],\"success\"],null],[[[1,\"                    \"],[8,[39,4],[[24,0,\"qa--settings__metaMarketingApi__hideInsights\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[28,[37,11],[[30,0,[\"collapseInsights\"]],[30,1,[\"id\"]]],null],\"small\",[28,[37,0],[\"account.meta_marketing_api.playground.ad_accounts.hide_insights_button\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[1,\"                    \"],[8,[39,4],[[24,0,\"qa--settings__metaMarketingApi__getInsights\"]],[[\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[28,[37,9],[[30,2,[\"status\"]],\"loading\"],null],[28,[37,11],[[28,[37,5],[[30,0,[\"fetchAccountInsightsTask\"]]],null],[30,1,[\"id\"]]],null],\"small\",[28,[37,0],[\"account.meta_marketing_api.playground.ad_accounts.get_insights_button\"],null],\"outline\"]],null],[1,\"\\n\"]],[]]],[1,\"                \"],[13],[1,\"\\n\\n\"],[41,[28,[37,9],[[30,2,[\"status\"]],\"success\"],null],[[[1,\"                  \"],[10,0],[14,0,\"tAC--mmaAccountTile__insights\"],[12],[1,\"\\n                    \"],[8,[39,12],null,[[\"@accountId\",\"@accountName\",\"@metrics\"],[[30,1,[\"id\"]],[30,1,[\"name\"]],[30,2,[\"metrics\"]]]],null],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,2,[\"status\"]],\"error\"],null],[[[1,\"                  \"],[10,2],[14,0,\"tAC--mmaInsightsError\"],[12],[1,\"\\n                    \"],[1,[28,[35,0],[\"account.meta_marketing_api.playground.ad_accounts.insights_error\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"]],[]],null]],[]]],[1,\"              \"],[13],[1,\"\\n\"]],[2,3]]]],[1]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,2],[14,0,\"u--text--light u--m__t__sm u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"account.meta_marketing_api.playground.ad_accounts.empty\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[10,\"details\"],[14,0,\"tAC--mmaRawDetails\"],[12],[1,\"\\n        \"],[10,\"summary\"],[14,0,\"tAC--mmaRawSummary\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"account.meta_marketing_api.playground.raw_response\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"pre\"],[14,0,\"tAC--mmaSnippet\"],[12],[1,[30,0,[\"adAccountsResult\"]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"    \"],[10,0],[14,0,\"tAC--mmaHero qa--settings__metaMarketingApi__hero\"],[12],[1,\"\\n      \"],[10,0],[14,\"aria-hidden\",\"true\"],[14,0,\"tAC--mmaHero__glyph\"],[12],[1,\"\\n        \"],[10,\"svg\"],[14,\"viewBox\",\"0 0 64 40\"],[12],[1,\"\\n          \"],[10,\"path\"],[14,\"d\",\"M 12 20 C 12 8, 28 8, 32 20 C 36 32, 52 32, 52 20 C 52 8, 36 8, 32 20 C 28 32, 12 32, 12 20 Z\"],[14,\"fill\",\"none\"],[14,\"stroke\",\"currentColor\"],[14,\"stroke-linecap\",\"round\"],[14,\"stroke-linejoin\",\"round\"],[14,\"stroke-width\",\"5\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"h4\"],[14,0,\"tAC--mmaHero__heading\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"account.meta_marketing_api.disconnected.hero_heading\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"tAC--mmaHero__subhead\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"account.meta_marketing_api.disconnected.hero_subhead\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,4],[[24,0,\"tAC--mmaHero__button qa--settings__metaMarketingApi__connect\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"metaMarketingApiAuth\",\"connect\"]],[28,[37,0],[\"account.meta_marketing_api.connect_button\"],null],\"default\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"account\",\"insights\",\"status\"],false,[\"t\",\"if\",\"did-insert\",\"format-date\",\"shared/ui/button\",\"perform\",\"each\",\"-track-array\",\"let\",\"eq\",\"or\",\"fn\",\"meta-marketing-api/insights-card\"]]",
    "moduleName": "settings/components/meta-marketing-api/index.hbs",
    "isStrictMode": false
  });
  const GRAPH_API_VERSION = 'v25.0';
  const GRAPH_API_BASE = 'https://graph.facebook.com';
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  // Meta Marketing API account_status enum.
  // https://developers.facebook.com/docs/marketing-api/reference/ad-account/
  const ACCOUNT_STATUS_MAP = {
    1: {
      tier: 'active',
      key: 'active'
    },
    2: {
      tier: 'inactive',
      key: 'disabled'
    },
    3: {
      tier: 'warning',
      key: 'unsettled'
    },
    7: {
      tier: 'warning',
      key: 'pending_review'
    },
    8: {
      tier: 'warning',
      key: 'pending_settlement'
    },
    9: {
      tier: 'warning',
      key: 'in_grace_period'
    },
    100: {
      tier: 'inactive',
      key: 'pending_closure'
    },
    101: {
      tier: 'inactive',
      key: 'closed'
    }
  };
  function buildGraphUrl(path, params) {
    const query = new URLSearchParams(params).toString();
    return `${GRAPH_API_BASE}/${GRAPH_API_VERSION}/${path}?${query}`;
  }
  function sumActions(actions) {
    if (!actions?.length) return undefined;
    const total = actions.reduce((acc, a) => acc + (Number.parseFloat(a.value) || 0), 0);
    return Number.isFinite(total) ? String(total) : undefined;
  }
  let SettingsMetaMarketingApiComponent = _exports.default = (_class = class SettingsMetaMarketingApiComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      // eslint-disable-next-line ember/no-unused-services -- referenced from template via {{this.metaMarketingApiAuth.connect}}
      _initializerDefineProperty(this, "metaMarketingApiAuth", _descriptor5, this);
      _initializerDefineProperty(this, "accountName", _descriptor6, this);
      _initializerDefineProperty(this, "adAccountsResult", _descriptor7, this);
      _initializerDefineProperty(this, "insightsByAccountId", _descriptor8, this);
      _defineProperty(this, "insightsFor", accountId => {
        return this.insightsByAccountId.get(accountId);
      });
      _defineProperty(this, "accountStatusInfo", account => {
        const status = account.account_status;
        const mapped = status === undefined ? undefined : ACCOUNT_STATUS_MAP[status];
        if (!mapped) {
          return {
            tier: 'unknown',
            label: this.intl.t('account.meta_marketing_api.account_status.unknown')
          };
        }
        return {
          tier: mapped.tier,
          label: this.intl.t(`account.meta_marketing_api.account_status.${mapped.key}`)
        };
      });
      _defineProperty(this, "copyTask", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (text) {
          if (!text) return;
          try {
            yield navigator.clipboard.writeText(text);
            this.alerts.success(this.intl.t('account.meta_marketing_api.copy_to_clipboard.success'));
          } catch (error) {
            this.errors.log(error);
            this.alerts.warning(this.intl.t('account.meta_marketing_api.copy_to_clipboard.failure'));
          }
        }
      }), null, "copyTask", null));
      _defineProperty(this, "fetchMeTask", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const raw = yield this.graphGet('me', {
            fields: 'id,name'
          });
          if (!raw) return;
          try {
            const parsed = JSON.parse(raw);
            if (!parsed.error && parsed.name) this.accountName = parsed.name;
          } catch {
            // leave accountName undefined; UI falls back to a generic label
          }
        }
      }), {
        drop: true
      }, "fetchMeTask", null));
      _defineProperty(this, "fetchAdAccountsTask", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.adAccountsResult = yield this.graphGet('me/adaccounts', {
            fields: 'id,name,business_name,account_status'
          });
          this.insightsByAccountId = new Map();
        }
      }), null, "fetchAdAccountsTask", null));
      _defineProperty(this, "fetchAccountInsightsTask", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (accountId) {
          this.setInsights(accountId, {
            status: 'loading'
          });
          const raw = yield this.graphGet(`${accountId}/insights`, {
            fields: 'clicks,impressions,spend,cost_per_unique_click,ctr,actions',
            date_preset: 'last_year'
          });
          try {
            const parsed = JSON.parse(raw);
            const row = parsed.data?.[0];
            if (parsed.error || !row) {
              this.setInsights(accountId, {
                status: 'error',
                raw
              });
              return;
            }
            const metrics = {
              clicks: row.clicks,
              impressions: row.impressions,
              spend: row.spend,
              cost_per_unique_click: row.cost_per_unique_click,
              ctr: row.ctr,
              total_actions: sumActions(row.actions)
            };
            this.setInsights(accountId, {
              status: 'success',
              metrics,
              raw
            });
          } catch {
            this.setInsights(accountId, {
              status: 'error',
              raw
            });
          }
        }
      }), {
        enqueue: true
      }, "fetchAccountInsightsTask", null));
    }
    // Wired to {{did-insert}}; the component may persist across disconnect/connect toggles.
    onConnectedCardInserted() {
      if (this.metaAdUser && !this.accountName) this.fetchMeTask.perform();
    }
    collapseInsights(accountId) {
      if (!this.insightsByAccountId.has(accountId)) return;
      const next = new Map(this.insightsByAccountId);
      next.delete(accountId);
      this.insightsByAccountId = next;
    }
    get parsedAdAccounts() {
      if (!this.adAccountsResult) return [];
      try {
        const parsed = JSON.parse(this.adAccountsResult);
        return parsed?.data ?? [];
      } catch {
        return [];
      }
    }
    get metaAdUser() {
      return this.auth.currentUserModel?.metaAdUser ?? undefined;
    }
    get isConnected() {
      return Boolean(this.metaAdUser);
    }
    get displayAccountName() {
      return this.accountName ?? this.intl.t('account.meta_marketing_api.unknown_account_name');
    }
    get tokenStatus() {
      const expiresAt = this.metaAdUser?.tokenExpiresAt;
      const connectedLabel = this.intl.t('account.meta_marketing_api.token_status.connected_label');
      if (!expiresAt) {
        return {
          tier: 'unknown',
          label: connectedLabel,
          detail: ''
        };
      }
      const diffMs = expiresAt.getTime() - Date.now();
      const days = Math.round(diffMs / MS_PER_DAY);
      if (days < 0) {
        return {
          tier: 'expired',
          label: this.intl.t('account.meta_marketing_api.token_status.expired_label'),
          detail: this.intl.t('account.meta_marketing_api.token_status.expired_days_ago', {
            days: Math.abs(days)
          }),
          daysUntilExpiry: days
        };
      }
      const detail = this.intl.t('account.meta_marketing_api.token_status.expires_in_days', {
        days
      });
      if (days < 7) return {
        tier: 'critical',
        label: connectedLabel,
        detail,
        daysUntilExpiry: days
      };
      if (days < 30) return {
        tier: 'expiring_soon',
        label: connectedLabel,
        detail,
        daysUntilExpiry: days
      };
      return {
        tier: 'healthy',
        label: connectedLabel,
        detail,
        daysUntilExpiry: days
      };
    }
    setInsights(accountId, state) {
      const next = new Map(this.insightsByAccountId);
      next.set(accountId, state);
      this.insightsByAccountId = next;
    }
    async graphGet(path, params) {
      const token = this.metaAdUser?.accessToken;
      if (!token) return '';
      try {
        const response = await fetch(buildGraphUrl(path, {
          ...params,
          access_token: token
        }));
        const body = await response.json();
        return JSON.stringify(body, undefined, 2);
      } catch (error) {
        this.errors.log(error);
        return JSON.stringify({
          error: String(error)
        }, undefined, 2);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "metaMarketingApiAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "accountName", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "adAccountsResult", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "insightsByAccountId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new Map();
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onConnectedCardInserted", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onConnectedCardInserted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collapseInsights", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "collapseInsights"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SettingsMetaMarketingApiComponent);
});